import React, { useState } from "react";
import {
  Modal,
  Button,
  ModalBody,
  ModalHeader,
  ModalFooter,
  Input,
  Label,
} from "reactstrap";

const ConsentModal = ({
  title = "Consent for Interview",
  isModalOpen,
  handleClose,
  cb,
  preAssessmentPublicData,
}) => {
  const [acceptTerms, setAcceptTerms] = useState(false);
  return (
    <Modal
      isOpen={isModalOpen}
      closeModal={handleClose}
      centered
      scrollable
      size="md"
      style={{ maxWidth: "800px", maxHeight: "1200px" }}
    >
      <div
        closeButton
        style={{
          paddingBottom: "0px",
          fontSize: "20px",
        }}
        className="fw-semibold modal-header"
      >
        {title}
      </div>
      <ModalBody
        className="mt-2"
        style={{
          paddingTop: "0px",
          paddingBottom: "0px",
        }}
      >
        <div
          className="p-2"
          style={{
            height: "320px",
            overflowY: "auto",
            border: "1px solid #e5e5e5",
            borderRadius: "10px",
            backgroundColor: "#F9FAFB",
            color: "#667087",
            fontSize: "16px",
          }}
        >
          <p>
            By proceeding, you agree to participate in an online interview
            conducted by an AI-powered virtual interviewer. The purpose of this
            interview is to evaluate your responses and provide feedback as part
            of the application process.
          </p>
          <p>Your participation signifies your consent to:</p>
          <ol>
            <li>
              <b> Data Collection, Retention, and Use</b>: Your interview will
              be recorded, and your information, including evaluation results,
              will be securely stored in our database for 12 months. This is to
              support recruitment opportunities and meet legal or compliance
              obligations. Your data may be processed by our recruitment team
              and AI systems for evaluation and potential job matching.
            </li>
            <li>
              <b>Data Protection and Privacy Compliance</b>: Your personal data
              will be protected using industry-standard measures to ensure
              confidentiality, integrity, and availability. In line with the
              <b> GDPR</b> and <b>PDPA</b>, your data will only be collected,
              used, or disclosed with your consent for the purposes stated here.
              It will not be shared with unauthorized third parties.
            </li>
          </ol>
          <p>Your Rights:</p>
          <ul>
            <li>
              You can withdraw your consent or request access, correction, or
              deletion of your data at any time by contacting &nbsp;
              <a
                href="mailto:recruiter@aven-sys.com"
                style={{
                  color: "blue", // Optional: Set the color to make it visually distinct
                  textDecoration: "underline", // Ensures the underline is present
                  cursor: "pointer", // Optional: Pointer cursor for better UX
                }}
              >
                {preAssessmentPublicData?.recruiterDetails?.email ||
                  "recruiter@aven-sys.com"}
              </a>
              .
            </li>
            <li>Withdrawal of consent may affect your application process.</li>
          </ul>

          <p>Please note:</p>
          <ul>
            <li>
              Microphone and video setup will follow this consent process, with
              separate permissions requested for activation.
            </li>
          </ul>
          <p>
            By continuing, you confirm your understanding and provide consent
            for the above. Thank you for your cooperation.
          </p>
        </div>
        {/* // Check Box for user to accept terms */}
        <div className="mt-3 d-flex align-items-baseline gap-2 ">
          <Input
            type="checkbox"
            id="acceptTerms"
            checked={acceptTerms}
            onChange={() => setAcceptTerms(!acceptTerms)}
          />
          <Label style={{ fontSize: "16px" }} for="acceptTerms">
            I accept the terms and conditions.
          </Label>
        </div>
      </ModalBody>
      <ModalFooter>
        <Button className="btn btn-secondary" onClick={handleClose}>
          Cancel
        </Button>
        <Button
          className="btn btn-success"
          onClick={cb}
          disabled={!acceptTerms}
        >
          Confirm
        </Button>
      </ModalFooter>
    </Modal>
  );
};

export default ConsentModal;
